import React, { forwardRef } from 'react'
import { Icon, iconDefaultProps, IconProps } from '../Icon'

type MessageTextSquare02IconProps = IconProps

const MessageTextSquare02Icon = forwardRef<
  SVGSVGElement,
  MessageTextSquare02IconProps
>((props: MessageTextSquare02IconProps, ref) => (
  <Icon {...props} ref={ref}>
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M7 8.5h5M7 12h8m-8 6v2.335c0 .533 0 .8.11.937a.5.5 0 0 0 .39.188c.176 0 .384-.167.8-.5l2.385-1.908c.487-.39.731-.585 1.002-.724.241-.122.497-.212.762-.267.299-.061.61-.061 1.235-.061H16.2c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C21 15.72 21 14.88 21 13.2V7.8c0-1.68 0-2.52-.327-3.162a3 3 0 0 0-1.311-1.311C18.72 3 17.88 3 16.2 3H7.8c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C3 5.28 3 6.12 3 7.8V14c0 .93 0 1.395.102 1.777a3 3 0 0 0 2.122 2.12C5.605 18 6.07 18 7 18Z"
      fill="none"
    ></path>
  </Icon>
))

MessageTextSquare02Icon.displayName = 'MessageTextSquare02Icon'
MessageTextSquare02Icon.defaultProps = iconDefaultProps

export type { MessageTextSquare02IconProps }
export { MessageTextSquare02Icon }
